import { mapState } from 'vuex'
export const infoTagsMixins = {
  data(){
    return {
      minusHeight:0
    }
  },
  methods:{
      changeInfoTags(){
          if(this.is_infoTags == "minus"){
            this.minusHeight = 32
          }else if(this.is_infoTags == "normal"){
            this.minusHeight = 0
          }if(this.is_infoTags == "add"){
            this.minusHeight = -32
          }
      }
  },
  updated(){
      this.$nextTick(()=>{
          this.changeInfoTags();
      })
  },
  computed:{
    ...mapState({
      is_infoTags:state=>state.index.is_infoTags
    })
  }
}